export default __webpack_public_path__ + "static/media/MSExcel_Security_3.fe017671.png";